import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { CountUp } from "countup.js";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class ScrollFunc {
    constructor() {
        this.init();
    }

    init() {
        this.onScroll();
        this.smoothScroll();

        //youtube埋め込みに変更
        //this.setVideo();
    }

    onScroll() {
        const revealElm = [...document.querySelectorAll(".js-scrollreveal")];
        let coutuped = false;

        revealElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top 85%",
                //markers: true,
                onEnter: () => {
                    el.classList.add("-reveal");

                    if (el.getAttribute("data-countup") && !coutuped) {
                        const numberElm = document.querySelector(".introduction__number");
                        const options = {
                            duration: 2,
                        };
                        let demo = new CountUp(numberElm, 321069578, options);
                        demo.start();
                        coutuped = true;
                    }
                },
            });
        });

        window.addEventListener("onLangChange", () => {
            ScrollTrigger.refresh();
            //console.log("refresh");
        });
    }

    smoothScroll() {
        const triggers = [...document.querySelectorAll(".js-smoothscroll")];
        const pagetop = [...document.querySelectorAll(".js-pagetop")];

        triggers.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                const hash = el.getAttribute("href");
                const offset = 0;
                gsap.to(window, { duration: 1, scrollTo: { y: hash, offsetY: offset }, ease: "circ.inOut" });
            });
        });

        pagetop.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                gsap.to(window, { duration: 1, scrollTo: { y: 0 }, ease: "circ.inOut" });
            });
        });
    }

    setVideo() {
        const videoElm = document.querySelector(".js-bgvideo");

        const options = {
            root: null,
            rootMargin: "0px 0px 100px 0px",
            threshold: 0,
        };

        const callback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (videoElm.getAttribute("src") === "") {
                        videoElm.setAttribute("src", "assets/img/top/pilotfilm/pf.mp4");
                        //console.log("setVideo");
                    }
                } else {
                }
            });
        };

        const observer = new IntersectionObserver(callback, options);
        const targetElem = document.querySelector("#pilotfilm");
        observer.observe(targetElem);
    }
}
